export default __webpack_public_path__ + "static/media/GreycliffCF-Regular.53e7f832.woff";